var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.8251 14.1663C6.57079 14.1663 6.31648 14.0697 6.1231 13.875C5.73501 13.4869 5.73501 12.8591 6.1231 12.471L12.4703 6.12406C12.8584 5.73599 13.4862 5.73599 13.8743 6.12406C14.2624 6.51214 14.2624 7.13994 13.8743 7.52802L7.52711 13.875C7.33373 14.0697 7.07942 14.1663 6.8251 14.1663Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1729 14.1663C12.9188 14.1663 12.6646 14.0697 12.4714 13.8752L6.12291 7.52667C5.73507 7.13891 5.73507 6.5116 6.12291 6.12383C6.51208 5.73607 7.13951 5.73607 7.52603 6.12383L13.8745 12.4723C14.2623 12.8601 14.2623 13.4874 13.8745 13.8752C13.6812 14.0697 13.4257 14.1663 13.1729 14.1663Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossWhite);
export default __webpack_public_path__ + "static/media/cross--white.0e7a5d326802956e225c790540684378.svg";
export { ForwardRef as ReactComponent };